<template>
  <v-ons-page id="calc-page">
    <v-ons-toolbar>
      <div class="center">IIDX HS Calc 2</div>
    </v-ons-toolbar>
    <v-ons-list id="option-list">
      <v-ons-list-item v-for="item in input_items">
        <label :for="item.id">{{item.description}}</label>
        <div class="right">
          <v-ons-input float type="number" placeholder="数値を入力" :input-id="item.id" v-model="item.value"></v-ons-input>
          <img class="clear" alt="clear" src="../assets/clear.png" @click="clear(item.id)">
        </div>
      </v-ons-list-item>
      <v-ons-list-item>
        <label :for="'adjust-to-bpm-before'">変化前BPMに緑数字を合わせる</label>
        <span class="list-item__subtitle">ノーマルHSの変更時のみ有効</span>
        <div class="right">
          <v-ons-switch input-id="adjust-to-bpm-before" v-model="adjust_to_bpm_before_checked"></v-ons-switch>
        </div>
      </v-ons-list-item>
    </v-ons-list>
    <div id="calc-button-container">
      <v-ons-button v-for="item in button_items" :id="item.id" class="calc-button" @click="calc(item.id)">
        {{item.description}}
      </v-ons-button>
    </div>
    <div id="calc-result-wrapper">
      <calc-result ref="calc_result" :calc_type="calc_type"></calc-result>
    </div>
  </v-ons-page>
</template>

<script>
  import Vue from 'vue'
  import CalcResult from './CalcResult'
  import anime from 'animejs'

  Vue.component('calc-result', CalcResult)

  export default {
    name: 'calc-page',
    data () {
      return {
        input_items: [
          {
            id: 'display-time',
            description: '緑数字',
            value: localStorage.getItem('display-time')
          },
          {
            id: 'bpm-before',
            description: 'BPM(変化前)',
            value: localStorage.getItem('bpm-before')
          },
          {
            id: 'bpm-after',
            description: 'BPM(変化後)',
            value: localStorage.getItem('bpm-after')
          }
        ],
        adjust_to_bpm_before_checked: Boolean(localStorage.getItem('adjust-to-bpm-before')),
        button_items: [
          {
            id: 'display-time-calc',
            description: '緑数字調節'
          },
          {
            id: 'fhs-calc',
            description: 'FHSで変更'
          },
          {
            id: 'nhs-calc',
            description: 'NHSで変更'
          },
          {
            id: 'fhs-to-nhs-calc',
            description: 'FHS → NHS'
          }
        ],
        calc_type: null
      }
    },
    methods: {
      clear: function (id) {
        let e = document.getElementById(id)
        e.value = ''
        e.focus()
      },
      calc: function (id) {
        this.calc_type = id
        this.$refs.calc_result.calc()
        this.saveOption()
      },
      getOption: function () {
        return {
          display_time: this.input_items.find(item => item.id === 'display-time').value,
          bpm_before: this.input_items.find(item => item.id === 'bpm-before').value,
          bpm_after: this.input_items.find(item => item.id === 'bpm-after').value,
          adjust_to_bpm_before: this.adjust_to_bpm_before_checked
        }
      },
      saveOption: function () {
        let option = this.getOption()
        localStorage.setItem('display-time', option.display_time)
        localStorage.setItem('bpm-before', option.bpm_before)
        localStorage.setItem('bpm-after', option.bpm_after)
        localStorage.setItem('adjust-to-bpm-before', String(+option.adjust_to_bpm_before))
      },
      applyBpm: function (music) {
        this.input_items[1].value = music.bpm_before
        this.input_items[2].value = music.bpm_after

        document.querySelectorAll('#bpm-before, #bpm-after').forEach(elem => {
          elem.style.backgroundColor = 'paleturquoise'
        })
        anime({
          targets: '#bpm-before, #bpm-after',
          backgroundColor: '#FFFFFF',
          duration: 700,
          easing: 'easeInCubic'
        })
      }
    },
    mounted: function () {
      document.addEventListener('applyBpm', e => {
        this.applyBpm(e.detail)
        document.querySelector('#calc-page').scrollTop = 0
      })
    }
  }
</script>

<style>
  #option-list {
    margin-top: 30px;
  }

  .page--material #option-list {
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
  }

  input {
    text-align: right;
  }

  img.clear {
    width: 20px;
    height: 20px;
    margin-left: 2px;
  }

  #calc-button-container {
    margin-top: 30px;
    text-align: center;
  }

  .calc-button {
    margin: 5px !important;
    width: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/components/CalcPage.vue